// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * Wraps `GET /api/v1/roles` — the tenant's role catalogue (raw IAM names,
 * e.g. "OrgAdmin"). Lives in `shared/` per ADR-0014; `get` stays imported
 * from the real `services/api` for its token/401 handling.
 */

import { get } from '../../helios/services/api';
import { ENDPOINTS } from '../utils/constants';
import type { RoleDTO } from '../types/iam';

/**
 * IAM works out the organisation from the signed-in user, so no tenant/org
 * parameter is sent. Roles are platform-wide and defined in IAM.
 */
export const getRoles = async (): Promise<RoleDTO[]> => get<RoleDTO[]>(ENDPOINTS.ROLES);
